import { createContext } from "react";

const ParentTransactionScreen = createContext<any>(null);

export default ParentTransactionScreen;
